<header class="topbar">
  <div class="brand">{{ 'app.name' | translate }}</div>
  <div class="topbar-actions">
    <app-language-switcher />
    @if (isAuthenticated() && loggedInEmail()) {
    <div class="user-menu" appClickOutside (appClickOutside)="closeUserMenu()">
      <button type="button" class="user-email" [title]="loggedInEmail()" [attr.aria-expanded]="isUserMenuOpen()"
        aria-haspopup="menu" (click)="toggleUserMenu()">
        {{ loggedInEmail() }}
      </button>

      @if (isUserMenuOpen()) {
      <div class="user-menu-dropdown" role="menu">
        <button type="button" role="menuitem" class="user-menu-dropdown__item" (click)="logout()">
          {{ 'app.logout' | translate }}
        </button>
      </div>
      }
    </div>
    }
  </div>
</header>

<main class="page-content">
  <router-outlet />
</main>

<app-toast />